import styled from 'styled-components';
import { canvas, text } from '@carvana/helios-styles';
import { body, heading } from '@carvana/helios-typography';
import { breakpoint } from '@carvana/helios-layout';

const BottomContent = styled.div`
  margin-top: auto;
`;
const Container = styled.div`
  align-items: flex-start;
  box-sizing: border-box;
  background-color: ${canvas.default};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  height: 340px;
  padding: 24px;

  ${breakpoint.md`
    height: 272px;
  `}

  &.expanded {
    height: auto;
  }
`;

const StarsContainer = styled.div`
  margin-bottom: 16px;
`;

const ReviewText = styled.p`
  color: ${text.default};
  display: -webkit-box;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
  ${body.md};

  ${breakpoint.md`
    -webkit-line-clamp: 4;
  `}

  &.expanded {
    display: block;
    margin-bottom: 16px;
  }
`;

const CustomerDetails = styled.div`
  display: flex;
  justify-self: flex-end;
  color: ${text.default};
  ${body.md};
`;

const CustomerName = styled.span`
  color: ${text.strong};
  ${heading.md};
`;

const Date = styled.p`
  color: ${text.default};
  ${body.sm}
`;

export {
  BottomContent,
  Container,
  StarsContainer,
  ReviewText,
  CustomerDetails,
  CustomerName,
  Date
};
